import TipNum01 from '@assets/images/guide/tip-number/tip-01.png'
import TipNum02 from '@assets/images/guide/tip-number/tip-02.png'
import TipNum03 from '@assets/images/guide/tip-number/tip-03.png'
import TipNum04 from '@assets/images/guide/tip-number/tip-04.png'
import TipNum05 from '@assets/images/guide/tip-number/tip-05.png'
import TipNum06 from '@assets/images/guide/tip-number/tip-06.png'
import TipNum07 from '@assets/images/guide/tip-number/tip-07.png'
import TipNum08 from '@assets/images/guide/tip-number/tip-08.png'
import TipNum09 from '@assets/images/guide/tip-number/tip-09.png'
import TipNum10 from '@assets/images/guide/tip-number/tip-10.png'
import TipNum11 from '@assets/images/guide/tip-number/tip-11.png'
import TipNum12 from '@assets/images/guide/tip-number/tip-12.png'
import TipNum13 from '@assets/images/guide/tip-number/tip-13.png'
import TipNum14 from '@assets/images/guide/tip-number/tip-14.png'
import TipNum15 from '@assets/images/guide/tip-number/tip-15.png'
import TipNum16 from '@assets/images/guide/tip-number/tip-16.png'
import TipNum17 from '@assets/images/guide/tip-number/tip-17.png'
import TipNum18 from '@assets/images/guide/tip-number/tip-18.png'
import TipNum19 from '@assets/images/guide/tip-number/tip-19.png'
import TipNum20 from '@assets/images/guide/tip-number/tip-20.png'
import TipNum21 from '@assets/images/guide/tip-number/tip-21.png'
import TipNum22 from '@assets/images/guide/tip-number/tip-22.png'
import TipNum23 from '@assets/images/guide/tip-number/tip-23.png'
import TipNum24 from '@assets/images/guide/tip-number/tip-24.png'
import TipNum25 from '@assets/images/guide/tip-number/tip-25.png'
import TipNum26 from '@assets/images/guide/tip-number/tip-26.png'
import TipNum27 from '@assets/images/guide/tip-number/tip-27.png'
import TipNum28 from '@assets/images/guide/tip-number/tip-28.png'
import TipNum29 from '@assets/images/guide/tip-number/tip-29.png'
import TipNum30 from '@assets/images/guide/tip-number/tip-30.png'

const TIP_NUMBER_IMAGES = [
  TipNum01,
  TipNum02,
  TipNum03,
  TipNum04,
  TipNum05,
  TipNum06,
  TipNum07,
  TipNum08,
  TipNum09,
  TipNum10,
  TipNum11,
  TipNum12,
  TipNum13,
  TipNum14,
  TipNum15,
  TipNum16,
  TipNum17,
  TipNum18,
  TipNum19,
  TipNum20,
  TipNum21,
  TipNum22,
  TipNum23,
  TipNum24,
  TipNum25,
  TipNum26,
  TipNum27,
  TipNum28,
  TipNum29,
  TipNum30,
]

export default TIP_NUMBER_IMAGES
